import React from 'react';
import { Card, Row, Col, Icon } from '@paypalcorp/pp-react';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import styles from './ClickableCardsSection.module.less';
import isAbsolutePath from '../../../util/isAbsolutePath';
import { trackButtonClick } from '../../../lib/fpti';

const CardsRow = ({ row }) => {
  const navigate = useNavigate();
  const handleNavigation = (key, url, behavior) => {
    trackButtonClick(key, url);
    if (isAbsolutePath(url)) {
      if (behavior === 'open') {
        window.open(url);
      } else {
        window.location.href = url;
      }
    } else {
      if (isAbsolutePath(url)) {
        window.location = url;
      } else {
        navigate(url);
      }
    }
  };

  return (
    <Row>
      {row.map(({ key, url, description, icon, badge }, index) => (
        <Col key={index} xs={12} sm={6} xxl={4} className={styles.card_container}>
          <Card onClick={() => handleNavigation(key, url, description)} className={styles.card}>
            <div className={styles.title_container}>
              {icon && <Icon name={icon} size="xs" />}
              <p className={styles.card_title}>{key}</p>
            </div>
            <p className={styles.card_description}>{badge}</p>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

CardsRow.propTypes = { row: PropTypes.array };
CardsRow.defaultProps = { row: [] };

export default CardsRow;
